import { createContext, useContext } from 'react'

const defaultAppConfig = {
  env: {},
  railsContext: {},
  user: {},
}

export const AppConfigContext = createContext(defaultAppConfig)

export const useAppConfig = () => useContext(AppConfigContext)
